/**
 * @generated SignedSource<<806f79dc5a56324cc27eacb503513117>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentPixAutomaticTitle_subscription$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
  } | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentPixAutomaticTitle_subscription";
};
export type PaymentPixAutomaticTitle_subscription$key = {
  readonly " $data"?: PaymentPixAutomaticTitle_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticTitle_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentPixAutomaticTitle_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PaymentSubscription",
  "abstractKey": null
};

(node as any).hash = "c3f2d4914d2b963c471f62abab1de289";

export default node;
